// extracted by mini-css-extract-plugin
export default {"esg_holder":"styles-module__esg_holder___tKz9f"};